import EmailVerifiedSuccessMessage from './EmailVerifiedSuccessMessage'
import Bold from '../Bold'
import ButtonView from './button/ButtonView'

export default {
  EmailVerifiedSuccessMessage,
  Bold,
  ButtonView,
}
